import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';
import Svg from '@styles/icons/svg';
import TouchableElement from '@components/common/touchableElement';
import { WIZARD_STEPS, isSimpleType as isSimpleTypeFn } from '@components/common/NCFileType/NCFileWizardNoERP/constants';
import { WizardProgressBarProps, WizardStep, TouchableRenderProps } from '@components/common/NCFileType/NCFileWizardNoERP/types';

const WizardProgressBar: React.FC<WizardProgressBarProps> = ({ currentStep, selectedType, skippedSteps, onStepPress, C, scale, font }) => {
  const isSimpleType = isSimpleTypeFn(selectedType);
  const visibleSteps = isSimpleType ? WIZARD_STEPS.filter((s) => s.step === 1 || s.step === 4) : WIZARD_STEPS;

  return (
    <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', paddingVertical: scale(12) }}>
      {visibleSteps.map((stepDef, index) => {
        const isActive = stepDef.step === currentStep;
        const isCompleted = stepDef.step < currentStep;
        const isTappable = isCompleted || isActive;
        const isSkipped = skippedSteps.has(stepDef.step);

        const dotBg = isActive
          ? C('Button/Light/Primary')
          : isCompleted && !isSkipped
            ? C('Status/Light/Active')
            : C('Background/Light/Field lighter');

        const dotTextColor = isActive || (isCompleted && !isSkipped) ? C('Label/Light/AlwaysLight Primary') : C('Label/Light/Quaternary');

        const labelColor = isActive ? C('Label/Light/Primary') : isCompleted && !isSkipped ? C('Status/Light/Active') : C('Label/Light/Tertiary');

        const stepContent = (
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <View
              style={{
                width: scale(26),
                height: scale(26),
                borderRadius: scale(13),
                backgroundColor: dotBg,
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: scale(5),
              }}
            >
              {isCompleted ? (
                <Svg icon="check" width={scale(12)} height={scale(12)} color="Label/Light/AlwaysLight Primary" />
              ) : (
                <Text style={[font['Caption 1'], { color: dotTextColor, fontWeight: '600' }]}>{stepDef.step}</Text>
              )}
            </View>
            <Text
              style={[
                font['Caption 1'],
                {
                  color: labelColor,
                  textDecorationLine: isSkipped ? 'line-through' : 'none',
                },
              ]}
            >
              {i18n.t(stepDef.label)}
            </Text>
          </View>
        );

        return (
          <React.Fragment key={stepDef.step}>
            {index > 0 && (
              <View
                style={{
                  width: scale(32),
                  height: scale(2),
                  backgroundColor: isCompleted ? C('Status/Light/Active') : C('Background/Light/Field lighter'),
                  marginHorizontal: scale(4),
                }}
              />
            )}
            {isTappable ? (
              <TouchableElement onPress={() => onStepPress(stepDef.step as WizardStep)} hitSlop={{ top: 4, bottom: 4, left: 4, right: 4 }}>
                {({ boxStyle }: TouchableRenderProps) => <View style={boxStyle}>{stepContent}</View>}
              </TouchableElement>
            ) : (
              stepContent
            )}
          </React.Fragment>
        );
      })}
    </View>
  );
};

export default WizardProgressBar;
